import {
    AlertTriangle,
    XCircle,
    Lock,
    Clock3,
} from "lucide-react";

type Variant =
    | "expired"
    | "incorrect"
    | "warning"
    | "blocked";

type Props = {
    variant: Variant;
    title: string;
    message: string;
    lockSeconds?: number;
    onNeedHelp?: () => void;
};

const styles = {
    expired: {
        container: "border-[#F4C35A] bg-[#FFF9EB]",
        text: "text-[#A15C00]",
        Icon: Clock3,
    },

    incorrect: {
        container: "border-[#F5A5A5] bg-[#FFF3F3]",
        text: "text-[#D92D20]",
        Icon: XCircle,
    },

    warning: {
        container: "border-[#F7C56A] bg-[#FFF9EC]",
        text: "text-[#C46A00]",
        Icon: AlertTriangle,
    },

    blocked: {
        container: "",
        text: "text-[#B42318]",
        Icon: Lock,
    },
};

export default function OtpStatusAlert({
    variant,
    title,
    message,
    onNeedHelp,
    lockSeconds = 0,
}: Props) {
    if (variant === "blocked") {

        const totalSeconds = lockSeconds;

        const minutes = Math.floor(totalSeconds / 60);

        const seconds = totalSeconds % 60;
        return (
            <div className="mt-16 flex flex-col items-center">

                <div className="mb-8 flex h-20 w-20 items-center justify-center rounded-2xl bg-[#FFF4E5]">
                    <Lock
                        size={40}
                        className="text-[#D92D20]"
                    />
                </div>

                <h2 className="text-[44px] font-semibold text-[#101828]">
                    {title}
                </h2>

                <p className="mt-4 max-w-[420px] text-center text-[18px] leading-8 text-[#667085]">
                    {message}
                </p>

                <h1 className="mt-10 text-[64px] font-bold tracking-wide text-[#D92D20]">
                    {minutes}:{String(seconds).padStart(2, "0")}
                </h1>

                <p className="mt-8 text-[18px] text-[#667085]">
                    Your account will unlock automatically.
                </p>

                <button
                    className="mt-10 text-[16px] font-semibold text-[#98A2B3]"
                    onClick={onNeedHelp}
                >
                    Need help?
                </button>
            </div>
        );
    }

    const config = styles[variant];
    const Icon = config.Icon;

    return (
        <div
            className={`mt-5 rounded-2xl border px-5 py-4 ${config.container}`}
        >
            <div className="flex items-start gap-3">
                <Icon
                    size={20}
                    className={`mt-0.5 ${config.text}`}
                />

                <div>
                    <h3
                        className={`text-[18px] font-semibold ${config.text}`}
                    >
                        {title}
                    </h3>

                    <p
                        className={`mt-1 text-[15px] leading-6 ${config.text}`}
                    >
                        {message}
                    </p>
                </div>
            </div>
        </div>
    );
}